import { spacing } from '@chegg-ui/theme'
import { FunctionComponent } from 'react'
import { useGetMessagePostion } from '@chegg-wt/core/hooks/useGetMessagePosition'
import { MessagePositionProps } from './types'
import { InfoTooltip } from './InfoToolTip'

export const WordsExceededInfoTooltip: FunctionComponent = () => {
  return <InfoTooltip name="WORD_LIMIT_EXCEEDS" top={-34} right={0} />
}

export const RewriteInfoTooltip: FunctionComponent<MessagePositionProps> = ({
  userClickPosition,
  parentRef,
}) => {
  const { top, left } = useGetMessagePostion(userClickPosition, parentRef)

  return <InfoTooltip name="HIGHLIGHT_REWRITE" top={top} left={left} isFixed />
}

export const SynonymsInfoTooltip: FunctionComponent<MessagePositionProps> = ({
  userClickPosition,
  parentRef,
}) => {
  const { top, left } = useGetMessagePostion(userClickPosition, parentRef)

  return <InfoTooltip name="HIGHLIGHT_SYNONYMS" top={top} left={left} isFixed />
}

export const ReviewInfoTooltip: FunctionComponent = () => {
  return <InfoTooltip name="REVIEW_AFTER_EDITS" top={spacing.px64} right={spacing.px48} />
}
